import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import type { Preset } from '../hooks/useSavedPresets';

export interface SavedPresetsDropdownProps {
  presets: Preset[];
  onSave: (name: string, url: string) => { ok: boolean; reason?: string };
  onRemove: (index: number) => void;
}

export function SavedPresetsDropdown({ presets, onSave, onRemove }: SavedPresetsDropdownProps) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const saveCurrent = () => {
    const name = window.prompt('Save current view as:');
    if (!name) return;
    const res = onSave(name.trim(), location.search);
    if (!res.ok) {
      window.alert(`Couldn't save preset: ${res.reason ?? 'unknown'}`);
    }
  };

  const loadPreset = (p: Preset) => {
    navigate({ search: p.url.startsWith('?') ? p.url.slice(1) : p.url });
    setOpen(false);
  };

  return (
    <div className="relative inline-block text-xs">
      <button type="button" onClick={() => setOpen((v) => !v)} className="rounded border border-slate-300 bg-white px-2 py-1">
        Presets ▾
      </button>
      {open && (
        <div className="absolute right-0 z-10 mt-1 w-56 rounded border border-slate-200 bg-white shadow">
          {presets.length === 0 && <div className="px-2 py-1 italic text-slate-500">No saved presets</div>}
          {presets.map((p, i) => (
            <div key={i} className="flex items-center gap-1 border-b border-slate-100 px-2 py-1 last:border-b-0">
              <button onClick={() => loadPreset(p)} className="flex-1 text-left text-slate-800 hover:underline">
                {p.name}
              </button>
              <button onClick={() => onRemove(i)} className="text-slate-400 hover:text-red-700">
                ✕
              </button>
            </div>
          ))}
          <button onClick={saveCurrent} className="block w-full border-t border-slate-200 px-2 py-1 text-left text-brand-dark hover:bg-slate-50">
            + Save current view as…
          </button>
        </div>
      )}
    </div>
  );
}
